import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row icon-main" }
const _hoisted_3 = { class: "row icon-event feather-icons icon-lists" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "mt-0" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "icon-popup" }
const _hoisted_9 = { class: "icon-first" }
const _hoisted_10 = { class: "mt-0" }
const _hoisted_11 = { class: "icon-class" }
const _hoisted_12 = { id: "fclass1" }
const _hoisted_13 = { class: "icon-last icon-last" }
const _hoisted_14 = { class: "form-inline" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = ["value"]

import { ref, defineAsyncComponent } from 'vue'
import { icon_bar_status, feather_icons } from "@/composables/common/allIcons"
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
interface iconss {
    class: string,
    tag: string
}

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexFeather',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const select_icon = ref<iconss>({
    class: 'home',
    tag: 'home'
})
function icon_bar(icon: string) {

    select_icon.value.class = icon;
    select_icon.value.tag = '<vue-feather type="' + icon + '"></vue-feather>';

    icon_bar_status.value = true;
}
function close_icon_bar() {
    icon_bar_status.value = false;
}
function copy_icon() {
    toast.info(' Code Copied to clipboard! ', {
        hideProgressBar: true, autoClose: 2000, theme: 'colored', position: 'bottom-right',
    });
    navigator.clipboard.writeText(select_icon.value.tag);
    document.execCommand('copy');

}

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Icons",
      mains: "Feather Icon",
      title: "Feather Icon"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), {
          colClass: "col-sm-12",
          cardhaderClass: "card-no-border pb-0",
          titleClass: "f-w-700",
          headerTitle: "true",
          title: "Feather Icon "
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(feather_icons), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-xxl-2 col-lg-4 col-md-6 icons-item",
                  key: index,
                  onClick: ($event: any) => (icon_bar(item.abbrivation))
                }, [
                  _createVNode(_component_vue_feather, {
                    type: item.abbrivation
                  }, null, 8, ["type"]),
                  _createElementVNode("h5", _hoisted_5, _toDisplayString(item.name), 1)
                ], 8, _hoisted_4))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-hover-bottom position-fixed fa-fa-icon-show-div", { 'opecity-0': !_unref(icon_bar_status) }]),
      style: _normalizeStyle([_unref(icon_bar_status) ? { 'display': 'block' } : { 'display': 'none' }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "close-icon",
              onClick: close_icon_bar
            }, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1)
            ]))]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_vue_feather, {
                class: "fa-2x",
                type: select_icon.value.class
              }, null, 8, ["type"]),
              _createElementVNode("h5", _hoisted_10, _toDisplayString(select_icon.value.class), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "icon-title" }, "data-feather", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(select_icon.value.class), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "icon-title" }, "Markup", -1)),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("input", {
                    class: "inp-val form-control m-r-10",
                    id: "input_copy",
                    type: "text",
                    value: select_icon.value.tag
                  }, null, 8, _hoisted_16),
                  _createElementVNode("button", {
                    class: "btn btn-primary notification",
                    onClick: copy_icon
                  }, "Copy text")
                ])
              ])
            ])
          ])
        ])
      ])
    ], 6)
  ], 64))
}
}

})